export default function nospecial(str) {
    if (!str) return '';
    return str.replace(/[^a-zA-Z0-9]/g, '');
}
